import { makeStyles } from '@mui/styles';


export const useStyles = makeStyles({
    customCheckbox: {
        width: 17,
        height: 17,
        borderRadius: "2px",
        border: "1px solid #C4D8FF",
        // backgroundColor: "#fff",
        color: "#fff",
        marginLeft: 0,
        padding: 0,
        '&.Mui-checked': {
            // backgroundColor: "#4a6fa1",
            // color: "#fff",
            borderColor: "transparent",
        },
        '& .MuiSvgIcon-root': {
            fontSize: 16,
        },
        '&.MuiCheckbox-indeterminate': {
            backgroundColor: "#c08401",
            borderColor: "transparent",
        },
        '&:hover': {
            // backgroundColor: "transparent",
            // color: "#fff",
        },
    },
});
